export const legalContent = {
    fr: {
        breadcrumbHome: 'Accueil',
        contactSectionTitle: 'Contactez-nous',
        contactIntro: 'Pour toute question concernant cette politique de confidentialité ou pour exercer vos droits, vous pouvez nous contacter via :',
        emailLabel: 'Email : contact@liguee1.com',
        whatsappLabel: 'WhatsApp :',
        whatsappCta: 'Cliquez ici pour nous contacter',
        conclusion: "Merci de choisir LIGUEE1. Nous sommes fiers de garantir votre confidentialité et de vous offrir un service de haute qualité sans compromettre votre sécurité ou votre anonymat.",
        privacy: {
            pageTitle: 'Politique de Confidentialité',
            sections: [
                {
                    title: '1. Informations que nous collectons',
                    body: "Nous collectons les informations que vous nous fournissez directement, telles que votre nom, adresse e-mail, et informations de paiement lorsque vous vous abonnez à nos services IPTV. Ces informations sont nécessaires pour fournir nos services et traiter vos paiements.",
                },
                {
                    title: '2. Comment nous utilisons vos informations',
                    body: "Nous utilisons vos informations pour fournir, maintenir et améliorer nos services IPTV, traiter vos paiements, communiquer avec vous concernant votre compte, et vous envoyer des mises à jour importantes sur nos services.",
                },
                {
                    title: '3. Partage de vos informations',
                    body: "Nous ne vendons, n'échangeons ni ne louons vos informations personnelles à des tiers. Nous pouvons partager vos informations uniquement avec nos prestataires de services de paiement pour traiter vos transactions, et uniquement dans la mesure nécessaire.",
                },
                {
                    title: '4. Sécurité de vos données',
                    body: "Nous mettons en œuvre des mesures de sécurité appropriées pour protéger vos informations personnelles contre l'accès non autorisé, la modification, la divulgation ou la destruction. Vos données sont chiffrées et stockées de manière sécurisée.",
                },
                {
                    title: '5. Vos droits',
                    body: "Vous avez le droit d'accéder, de corriger ou de supprimer vos informations personnelles à tout moment. Vous pouvez également vous opposer au traitement de vos données ou demander la portabilité de vos informations.",
                },
            ],
        },
        terms: {
            pageTitle: "Conditions Générales d'Utilisation",
            sections: [
                {
                    title: '1. Acceptation des conditions',
                    body: "En accédant à notre site web et en utilisant nos services IPTV, vous acceptez les présentes Conditions Générales d'Utilisation. Si vous n'êtes pas d'accord avec ces conditions, veuillez ne pas utiliser notre site ou nos services.",
                },
                {
                    title: '2. Services IPTV',
                    body: "LIGUEE1 propose des abonnements IPTV pour vous permettre de profiter d'une grande variété de chaînes et de contenus. Ces abonnements sont conçus pour offrir une expérience de visionnage de qualité sans nécessiter de collecte de vos informations personnelles.",
                    body2: "Les codes d'activation et les instructions d'installation vous seront fournis immédiatement après votre achat.",
                },
                {
                    title: '3. Confidentialité',
                    body: "Nous ne collectons aucune donnée personnelle sur nos utilisateurs. Cela signifie que votre nom, votre adresse, vos informations de paiement ou tout autre détail identifiable ne sont ni collectés ni stockés par LIGUEE1. Votre confidentialité est garantie, et nous avons mis en place des mesures pour empêcher toute collecte de données par des tiers.",
                    body2: 'En utilisant nos services, vous pouvez être assuré que vos activités restent entièrement anonymes et sécurisées.',
                },
                {
                    title: '4. Paiement',
                    body: "Les paiements sont effectués via des plateformes sécurisées tierces. LIGUEE1 ne stocke aucune information de paiement. Veuillez suivre les instructions fournies pour finaliser votre achat en toute sécurité.",
                },
                {
                    title: '5. Utilisation des services',
                    body: "Les services IPTV fournis par LIGUEE1 sont destinés à un usage personnel uniquement. Vous ne devez pas partager, redistribuer ou revendre les codes d'activation ou le contenu fourni par nos services. Toute utilisation abusive peut entraîner la résiliation de votre abonnement sans remboursement.",
                },
                {
                    title: '6. Responsabilité',
                    body: "LIGUEE1 s'engage à fournir des services IPTV de haute qualité. Cependant, nous ne pouvons garantir une disponibilité ininterrompue en raison de facteurs externes tels que des pannes Internet ou des problèmes techniques. Nous déclinons toute responsabilité pour les interruptions indépendantes de notre contrôle.",
                },
                {
                    title: '7. Droits de propriété intellectuelle',
                    body: "Tout le contenu fourni par nos services IPTV, y compris les chaînes, les films et les séries, est protégé par des droits d'auteur et des lois sur la propriété intellectuelle. Vous ne devez pas enregistrer, distribuer ou copier ce contenu.",
                },
                {
                    title: '8. Modifications des conditions',
                    body: "Nous nous réservons le droit de modifier ces conditions à tout moment. Toute modification sera publiée sur notre site web. En continuant à utiliser nos services après une modification, vous acceptez les nouvelles conditions.",
                },
            ],
        },
        refund: {
            pageTitle: 'Politique de Remboursement',
            sections: [
                {
                    title: '1. Droit au remboursement',
                    body: "Chez LIGUEE1, nous nous engageons à garantir votre satisfaction. C'est pourquoi nous offrons une politique de remboursement de 15 jours pour tous nos utilisateurs. Si, pour une raison quelconque, vous n'êtes pas satisfait de nos services, vous pouvez demander un remboursement dans un délai de 15 jours après votre achat.",
                },
                {
                    title: '2. Conditions de remboursement',
                    intro: 'Pour être éligible à un remboursement, les conditions suivantes doivent être remplies :',
                    list: [
                        "La demande doit être effectuée dans les 15 jours suivant la date d'achat.",
                        'Vous devez fournir une preuve d\'achat valide, telle que votre reçu ou votre email de confirmation.',
                        "Les remboursements ne sont pas disponibles si vous avez déjà utilisé plus de 50% de votre période d'abonnement.",
                    ],
                },
                {
                    title: '3. Processus de demande',
                    intro: 'Pour demander un remboursement, veuillez suivre ces étapes :',
                    orderedList: [
                        "La demande doit être effectuée dans les 15 jours suivant la date d'achat.",
                        'Vous devez fournir une preuve d\'achat valide, telle que votre reçu ou votre email de confirmation.',
                        "Les remboursements ne sont pas disponibles si vous avez déjà utilisé plus de 50% de votre période d'abonnement.",
                    ],
                },
                {
                    title: '4. Mode de remboursement',
                    body: "Si votre demande de remboursement est approuvée, le montant sera retourné via le même mode de paiement que celui utilisé lors de votre achat. Le délai de traitement peut varier en fonction de votre fournisseur de paiement.",
                },
            ],
        },
    },
    es: {
        breadcrumbHome: 'Inicio',
        contactSectionTitle: 'Contáctanos',
        contactIntro: 'Para cualquier pregunta sobre esta política de privacidad o para ejercer tus derechos, puedes contactarnos a través de:',
        emailLabel: 'Email: contact@liguee1.com',
        whatsappLabel: 'WhatsApp:',
        whatsappCta: 'Haz clic aquí para contactarnos',
        conclusion: 'Gracias por elegir LIGUEE1. Nos enorgullece garantizar tu privacidad y ofrecerte un servicio de alta calidad sin comprometer tu seguridad ni tu anonimato.',
        privacy: {
            pageTitle: 'Política de Privacidad',
            sections: [
                {
                    title: '1. Información que recopilamos',
                    body: 'Recopilamos la información que nos proporcionas directamente, como tu nombre, dirección de email e información de pago cuando te suscribes a nuestros servicios IPTV. Esta información es necesaria para prestar nuestros servicios y procesar tus pagos.',
                },
                {
                    title: '2. Cómo utilizamos tu información',
                    body: 'Utilizamos tu información para prestar, mantener y mejorar nuestros servicios IPTV, procesar tus pagos, comunicarnos contigo sobre tu cuenta y enviarte actualizaciones importantes sobre nuestros servicios.',
                },
                {
                    title: '3. Cómo compartimos tu información',
                    body: 'No vendemos, intercambiamos ni alquilamos tu información personal a terceros. Solo podemos compartir tu información con nuestros proveedores de servicios de pago para procesar tus transacciones, y únicamente en la medida necesaria.',
                },
                {
                    title: '4. Seguridad de tus datos',
                    body: 'Aplicamos medidas de seguridad adecuadas para proteger tu información personal frente al acceso no autorizado, la modificación, la divulgación o la destrucción. Tus datos se cifran y se almacenan de forma segura.',
                },
                {
                    title: '5. Tus derechos',
                    body: 'Tienes derecho a acceder, corregir o eliminar tu información personal en cualquier momento. También puedes oponerte al tratamiento de tus datos o solicitar la portabilidad de tu información.',
                },
            ],
        },
        terms: {
            pageTitle: 'Términos y Condiciones de Uso',
            sections: [
                {
                    title: '1. Aceptación de las condiciones',
                    body: 'Al acceder a nuestro sitio web y utilizar nuestros servicios IPTV, aceptas los presentes Términos y Condiciones de Uso. Si no estás de acuerdo con estas condiciones, por favor no utilices nuestro sitio ni nuestros servicios.',
                },
                {
                    title: '2. Servicios IPTV',
                    body: 'LIGUEE1 ofrece suscripciones IPTV para que disfrutes de una gran variedad de canales y contenidos. Estas suscripciones están diseñadas para ofrecer una experiencia de visualización de calidad sin necesidad de recopilar tus datos personales.',
                    body2: 'Los códigos de activación y las instrucciones de instalación te serán enviados inmediatamente después de tu compra.',
                },
                {
                    title: '3. Privacidad',
                    body: 'No recopilamos ningún dato personal de nuestros usuarios. Esto significa que tu nombre, dirección, información de pago o cualquier otro dato identificable no son recopilados ni almacenados por LIGUEE1. Tu privacidad está garantizada y hemos implementado medidas para impedir cualquier recopilación de datos por parte de terceros.',
                    body2: 'Al utilizar nuestros servicios, puedes estar seguro de que tu actividad permanece totalmente anónima y segura.',
                },
                {
                    title: '4. Pago',
                    body: 'Los pagos se realizan a través de plataformas seguras de terceros. LIGUEE1 no almacena ninguna información de pago. Sigue las instrucciones proporcionadas para completar tu compra de forma segura.',
                },
                {
                    title: '5. Uso de los servicios',
                    body: 'Los servicios IPTV proporcionados por LIGUEE1 están destinados únicamente a un uso personal. No debes compartir, redistribuir ni revender los códigos de activación ni el contenido proporcionado por nuestros servicios. Cualquier uso indebido puede provocar la cancelación de tu suscripción sin reembolso.',
                },
                {
                    title: '6. Responsabilidad',
                    body: 'LIGUEE1 se compromete a ofrecer servicios IPTV de alta calidad. Sin embargo, no podemos garantizar una disponibilidad ininterrumpida debido a factores externos como cortes de Internet o problemas técnicos. Declinamos toda responsabilidad por interrupciones ajenas a nuestro control.',
                },
                {
                    title: '7. Derechos de propiedad intelectual',
                    body: 'Todo el contenido proporcionado por nuestros servicios IPTV, incluidos los canales, las películas y las series, está protegido por derechos de autor y leyes de propiedad intelectual. No debes grabar, distribuir ni copiar este contenido.',
                },
                {
                    title: '8. Modificaciones de las condiciones',
                    body: 'Nos reservamos el derecho de modificar estas condiciones en cualquier momento. Cualquier modificación se publicará en nuestro sitio web. Si continúas utilizando nuestros servicios después de una modificación, aceptas las nuevas condiciones.',
                },
            ],
        },
        refund: {
            pageTitle: 'Política de Reembolso',
            sections: [
                {
                    title: '1. Derecho al reembolso',
                    body: 'En LIGUEE1 nos comprometemos a garantizar tu satisfacción. Por ello, ofrecemos una política de reembolso de 15 días para todos nuestros usuarios. Si, por cualquier motivo, no estás satisfecho con nuestros servicios, puedes solicitar un reembolso dentro de los 15 días posteriores a tu compra.',
                },
                {
                    title: '2. Condiciones de reembolso',
                    intro: 'Para tener derecho a un reembolso, deben cumplirse las siguientes condiciones:',
                    list: [
                        'La solicitud debe realizarse dentro de los 15 días posteriores a la fecha de compra.',
                        'Debes aportar una prueba de compra válida, como tu recibo o tu email de confirmación.',
                        'Los reembolsos no están disponibles si ya has utilizado más del 50% de tu período de suscripción.',
                    ],
                },
                {
                    title: '3. Proceso de solicitud',
                    intro: 'Para solicitar un reembolso, sigue estos pasos:',
                    orderedList: [
                        'La solicitud debe realizarse dentro de los 15 días posteriores a la fecha de compra.',
                        'Debes aportar una prueba de compra válida, como tu recibo o tu email de confirmación.',
                        'Los reembolsos no están disponibles si ya has utilizado más del 50% de tu período de suscripción.',
                    ],
                },
                {
                    title: '4. Método de reembolso',
                    body: 'Si tu solicitud de reembolso es aprobada, el importe se devolverá mediante el mismo método de pago utilizado en tu compra. El plazo de tramitación puede variar según tu proveedor de pago.',
                },
            ],
        },
    },
};
